import { User } from "@app/shared/models";
import { OperationType } from "@app/tool/model/operationType.model";

export class ToolIntervention {

    public id: number;
    public launchDate: Date;
    public launchedBy: User;
    public interventionStart: Date;
    public interventionEnd: Date;
    public operationType: OperationType;
    public ticketId: number;
    public responsible: User;
    public operationHasTask: boolean;
    public isOperationResolved: boolean;

    constructor(interventions: any = {}) {
        this.id = interventions.id;
        this.launchDate = interventions.launchDate;
        this.launchedBy = new User(interventions.launchedBy);
        this.interventionStart = interventions.interventionStart;
        this.interventionEnd = interventions.interventionEnd;
        this.operationType = interventions.operationType;
        this.ticketId = interventions.ticketId;
        this.responsible =  this.mapUser(interventions.responsible)
        this.isOperationResolved =  interventions.isOperationResolved;
        this.operationHasTask = interventions.operationHasTask || false
    }
    mapUser(user) {
        return user ? new User(user) : new User();
    }
    get type() {
        return "tool-intervention";
    }
}
